import React from 'react';

export const Skeleton = () => (
  <div className="my-10">
    <div className="flex items-center justify-center gap-4">
      <div className="h-18 flex w-40 flex-col items-center justify-center rounded-xl bg-white">
        <div className="mb-2 h-6 w-10 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
      </div>
      <div className="h-18 flex w-40 flex-col items-center justify-center rounded-xl bg-white">
        <div className="mb-2 h-6 w-10 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
      </div>
      <div className="h-18 flex w-40 flex-col items-center justify-center rounded-xl bg-white">
        <div className="mb-2 h-6 w-10 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
    <div className="mx-auto mb-2 mt-6 h-4 max-w-md animate-pulse rounded bg-gray-200" />
    <div className="mt-8 flex items-center justify-center gap-3 text-sm">
        <div className="h-12 w-35 animate-pulse rounded-lg bg-gray-200" />
        <div className="h-12 w-35 animate-pulse rounded-lg bg-gray-200" />
    </div>
  </div>
);
